import { Form, useFormContext } from "@/components/form";
import { getAllProveedores } from "@/features/auxiliar/proveedores/api/get-all-proveedores";
import { getProveedor } from "@/features/auxiliar/proveedores/api/get-proveedor";
import { Stack } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import { Dialog, Drawer, ModalContextExtractor, ModalHeader, useOpenModal } from "@/components/modal";
import { AddProveedorMutation } from "@/features/auxiliar/proveedores/api/add-proveedor";
import { notify } from "@/shared/notification";
import CompraProveedorManualSearch from "./compra-proveedor-manual-search";
import { SchemaFormHook } from "@/components/form";
import AddProveedorForm, { addProveedorFormSchema } from "@/features/auxiliar/proveedores/components/add-proveedor-form";

export default function CompraGeneralInfoFields() {
    const openModal = useOpenModal();

    const form = useFormContext();

    return <Stack gap={2} direction={"row"} flexWrap={"wrap"}>
        <Stack flex={"1 1 auto"}>
            <Form.TextField name="numComprobante" label="N° de Comprobante" size="small" />
        </Stack>
        <Stack flex={"10 1 250px"} direction={"row"} gap={1}>
            <Stack flex={1}>
                <Form.ModelComboBox name="proveedorId" label="Proveedor" get={getProveedor} getAll={getAllProveedores} size="small" />
            </Stack>
            <Form.IconButton onClick={() => openModal("addProveedor")}><AddIcon /></Form.IconButton>
            <Form.IconButton onClick={() => openModal("searchProveedor")}><SearchIcon /></Form.IconButton>
        </Stack>
        <Stack flex={"1 1 auto"}>
            <Form.DatePicker name="fecha" label="Fecha" size="small" />
        </Stack>

        <Drawer code="addProveedor">
            <ModalHeader>Agregar Proveedor</ModalHeader>
            <AddProveedorMutation>
                {mutation => <SchemaFormHook
                    schema={addProveedorFormSchema}
                    onSubmit={async ({ value }) => {
                        const proveedor = await mutation.mutateAsync(value);
                        notify("El proveedor se ha agregado correctamente.");
                        form.setFieldValue("proveedorId", proveedor.id);
                    }}
                    submitOnce
                    closeModalOnSubmit
                >
                    {form => <AddProveedorForm form={form} margin={3} />}
                </SchemaFormHook>}
            </AddProveedorMutation>
        </Drawer>

        <Dialog code="searchProveedor" size="lg">
            <ModalHeader>Buscar Proveedor</ModalHeader>
            <ModalContextExtractor>
                {({ handleClose }) => <CompraProveedorManualSearch
                    padding={3}
                    onProveedorSelect={proveedor => {
                        form.setFieldValue("proveedorId", proveedor.id);
                        handleClose();
                    }}
                />}
            </ModalContextExtractor>
        </Dialog>
    </Stack>
}